import { OnEventDispatcher } from "./core/on-event-dispatcher";
import { Application } from "./main";
import { HtmlPartials } from "../../shared/htmlpartials";
import { ReceptionSearch } from "./map/components/receptionsearch";
import { MapSideView } from "./map/components/mapsideview";

export class MapView extends OnEventDispatcher {

    elm: JQuery<HTMLElement>;

    sideView: MapSideView;
    receptionSearch: ReceptionSearch;
    
    constructor(container:JQuery<HTMLElement>, data:any) {
        super();

        let uid:string = container.attr("data-uid");

        this.elm = container.find("> .map-view");

        if(this.elm!=null&&this.elm.length>0) {
            if(uid!=data?.uid) {
                console.log("uid change");
                this.elm = null;
                container.html("");
            } else {
                //console.log("uid same");
            }
        }

        if(this.elm==null||this.elm.length==0) {
            this.elm = $(HtmlPartials.getVaxiMapView(data)).appendTo(container);
        }

        this.sideView = new MapSideView(this.elm.find("> .map-sideview-container"));
        this.receptionSearch = new ReceptionSearch(this.elm.find("> .map-search-container"));
    }
}